"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.storageProviderActions = exports.initialState = void 0;
const _reduxjs_1 = require("../../utils/@reduxjs");
const REDUCER_KEY = 'storageProvider';
exports.initialState = {
    storageInitialized: false,
    storage: {},
};
const storageProviderSlice = (0, _reduxjs_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        initStorage(state, action) {
            state.storageInitialized = action.payload.storageInitialized;
        },
        // Triggers saga, which calls setInitialValues action
        setStorage() { },
        setInitialValues(state, action) {
            state.storage = action.payload.storage;
        },
        setItem(state, action) {
            state.storage[action.payload.key] = JSON.stringify(action.payload.value);
        },
        removeItem(state, action) {
            delete state.storage[action.payload.key];
        },
        clear(state) {
            state.storage = {};
        },
    },
});
exports.storageProviderActions = storageProviderSlice.actions, exports.reducer = storageProviderSlice.reducer, exports.sliceKey = storageProviderSlice.name;
//# sourceMappingURL=slice.js.map